import React, { cloneElement, isValidElement } from 'react';
import { Tooltip } from '@mui/material';

const READONLY_TOOLTIP = 'Read-only role — request Full access to perform this action.';

interface GuardedControlProps {
  disabled: boolean;
  tooltip?: string;
  children: React.ReactElement;
}

/**
 * Every write-capable control in Customer Orgs must go through this wrapper, not raw
 * disabled buttons — the Lovable prototype disabled some write controls without any
 * explanation, which read as broken. This guarantees a consistent tooltip everywhere.
 */
export function GuardedControl({ disabled, tooltip, children }: GuardedControlProps) {
  if (!disabled) return children;

  const disabledChild = isValidElement(children)
    ? cloneElement(children as React.ReactElement<any>, { disabled: true })
    : children;

  return (
    <Tooltip title={tooltip ?? READONLY_TOOLTIP}>
      <span>{disabledChild}</span>
    </Tooltip>
  );
}
